import { Brand } from '@calo/types';
import MealoPlanService from './MealoPlanService';
import CaloPlanService from './CaloPlanService';
export default class PlanService {
    constructor(brand, magicPrice) {
        if (magicPrice && magicPrice === true) {
            this.planService = new CaloPlanService(magicPrice);
        }
        else if (brand === Brand.MEALO) {
            this.planService = new MealoPlanService();
        }
        else {
            this.planService = new CaloPlanService();
        }
    }
    getFoodTypeForPlan(planType, country) {
        return this.planService.getFoodTypeForPlan(planType, country);
    }
    getFoodTypePrice(foodType, dietType, currency) {
        return this.planService.getFoodTypePrice(foodType, dietType, currency);
    }
    getPlan({ planType, foodType, extras, dietType, frequency, currency }) {
        return this.planService.getPlan({ planType, foodType, extras, dietType, frequency, currency });
    }
    getPlanPrice(plan, deliveryDays, currency) {
        return this.planService.getPlanPrice(plan, deliveryDays, currency);
    }
}
